// extracted by mini-css-extract-plugin
export default {"invest_list":"Recurring-items_invest_list__8Hpeg","list_item":"Recurring-items_list_item__ZU5o4"};